/* eslint-disable @typescript-eslint/no-explicit-any */
import * as R from 'ramda';

export function setupField(props: any) {
  const { field, form } = props;
  const { touched, errors, setFieldValue, setFieldTouched } = form;
  const handleBlur = (e: any) => {
    const { name, id } = e.target;
    setFieldTouched(name || id);
  };
  const handleChange = (e: any, data: any) => {
    const { name, value } = data;
    setFieldValue(name, value);
  };
  const error = !!touched[field.name] && !!errors[field.name];
  return { handleBlur, handleChange, field, error };
}

export function setInitialValues(fields: any, props: any) {
  const values = props.initialValues || {
    serviceProviderId: R.path(['serviceProviders', 'myProvider', 'id'], props)
  };
  const finalFields = R.uniq([...fields, 'id', 'serviceProviderId']);
  return finalFields.reduce((acc: any, f: any) => {
    const key = f.key || f;
    const defaultValue = typeof f.value !== 'undefined' ? f.value : '';
    acc[key] = values[key] || defaultValue;
    return acc;
  }, {});
}
